module.exports = __webpack_public_path__ + "static/media/upload_grey.551eefb7.svg";